export enum AppPaths {
	EMAIL_CONFIRMATION = 'email-confirmation',

	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',
	HANDOFF = 'handoff',

	ACCOUNT = 'account',

	CREATOR = 'creator',

	INVESTMENTS = 'investments',
	ARCHIVED_INVESTMENTS = 'archived-investments',

	ORDER_CONFIRMATION = 'order-confirmation',

	COMPANY = 'company',

	PRODUCT_TYPES = 'product-types',
	PROJECTS = 'projects',
	PROJECT_TEMPLATES = 'project-templates',
}
